import styles from "./ProjectSection.module.css";

import {useEffect, useState} from "react";
import ProjectList from "./ProjectList";
import PageNotFound from "../App.js";

async function fetchProjects(setState) {
  var i = 3;
  var result = null;
  while (i-- > 0 && result == null){
    var fetchRes;
    try {
      fetchRes = await fetch("/api/listProjects");
      result = await (fetchRes).json();
    } catch (error) {
      console.log("Failed to fetch projects");    
    }
  }
  setState(result);
  if (result != null)
    console.log("fetched projects");
}

export default function ProjectsSection(props){
  
  
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetchProjects(setProjects);
  }, []);
  
  //const projects = props.projects;

  /*const images = [{url:joystickImg1, width: 2560, height: 1329}, {url:joystickImg2, width: 2071, height: 1824}];

  var project = [{"link": "/projects/test", "name": "Glider flight simulator joystick", 
  "images":images, "description":"A flight joystick I designed, 3d printed, and programmed so that I can practice gliding without spending a small fortune each time I fly."}
  ];
  projects = projects.concat(projects).concat(projects);
  projects = projects.concat(projects);
  
  var result = fetch("/api/listProjects");
  
  projects = JSON.parse(result.body);
  */
  const projectsComponent = projects != null ? <ProjectList projects={projects}/> : <span></span>;

  return (

    <section className={styles.projects_section}>

      <h1 className={styles.heading}>My projects</h1>
      <hr className={styles.heading_seperator}/>

      <div className={styles.project_list_container}>
        {projectsComponent}
      </div>

    </section>



  );
}